<template>
	<v-container>
		<v-form v-model="permiteGuardar">
		<v-row>
			<v-col cols="12" sm="2">
				<v-text-field
					label="Folio de Solicitud"
					v-model="datosSeguimiento.idSolicitud"
					readonly
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="2">
				<v-text-field
					label="Fecha de Solicitud"
					v-model="datosSeguimiento.fechaSolicitud"
					readonly
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="3">
				<v-text-field
					label="Estatus de Solicitud"
					v-model="datosSeguimiento.status"
					readonly
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="5">
				<v-text-field
					label="Nombre del Paciente"
					v-model="datosSeguimiento.paciente"
					readonly
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-combobox 
					label="Estatus Intervencion" 
					v-model="statusIntervencion" 
					:items="statusIntervencionLista" 
					item-text="descripcion" 
					item-value="id"
				></v-combobox>
			</v-col>
			<v-col cols="12" sm="2">
				<v-text-field 
					label="Teléfono 1" 
					v-model="datosSeguimiento.tel1" 
					readonly
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="2">
				<v-text-field 
					label="Teléfono 2" 
					v-model="datosSeguimiento.tel2" 
					readonly
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="2">
				<v-text-field 
					label="Teléfono 3" 
					v-model="datosSeguimiento.tel3" 
					readonly
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-textarea
					label="Anotaciones"
					v-model="anotaciones"
					rows="5"
					background-color="teal lighten-5"
					color="teal teal-darken-4"
					prepend-icon="mdi-comment"
					:counter="3000"
					:rules="anotacionesRules"
				></v-textarea>
			</v-col>
			<v-col cols="12" sm="6">
				<v-textarea
					label="Observaciones"
					v-model="observaciones"
					rows="5"
					background-color="teal lighten-5"
					color="teal teal-darken-4"
					prepend-icon="mdi-comment"
					:counter="3000"
					:rules="observacionesRules"
				></v-textarea>
			</v-col>
		</v-row>
		<v-row>
				<v-btn color="info" :disabled="!permiteGuardar" @click="guardaSeguimiento">Guardar</v-btn>
				<v-spacer></v-spacer>
				<v-btn color="success" @click="cancelar">Cancelar</v-btn>
		</v-row>
	</v-form>
	</v-container>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi.js'
export default {
	name: 'DetalleSeguimiento',
	data() {
		return {
			folio: 0,
			anotaciones: '',
			observaciones: '',
			permiteGuardar: true,
			respuesta: '',
			statusIntervencion: '',
			statusIntervencionLista: [],
			respuestaStatusIntervencion: '',
			anotacionesRules: [
				v => !!v || "Debe especificar alguna anotación",
				v => v.length <= 3000 || "El máximo de caracteres es de 3,000"
			],
			observacionesRules: [
				v => v.length <= 3000 || "El máximo de caracteres es de 3,000"
			],
		}
	},
	props: {
		datosSeguimiento: {
			type: Object,
			requiered: true,
		}
	},
	mounted: function(){
		ServiciosApi.statusPorTipo(5)
			.then(response=> {
				this.respuestaStatusIntervencion = response.data
				this.statusIntervencionLista = this.respuestaStatusIntervencion.datos
			})
			.catch(error => {
				console.log("Hubieron errores al montar buscando estatus", error.response)
			})
	},
	methods: {
		guardaSeguimiento() {
			let infoSeguimiento = {
				notas: this.anotaciones,
				observaciones: this.observaciones,
				idSolicitud : this.datosSeguimiento.idSolicitud,
				idStatus: this.statusIntervencion.id
			}
			console.log("status intervencion", this.statusIntervencion.id)
			console.log("Oprimio boton Guardar", infoSeguimiento)
			ServiciosApi.nuevaLlamadaSeguimiento(infoSeguimiento)
				.then(response => {
					this.respuesta = response.data
					console.log("Datos", this.respuesta)
				})
				.catch(error =>{
					console.log("Hubieron errores", error.response)
				})
			this.$emit('cancela-detalle', 0)
		},
		cancelar() {
			console.log("Oprimio boton Cancelar")
			this.folio = 0
			this.$emit('cancela-detalle',this.folio)
		},
			
	},
}
</script>
